import React, { Component } from 'react';
import './style.scss'
import PropTypes from 'prop-types';
import { connect } from 'react-redux'

import { profileSelector } from '../../../../modules/profile';
import InputField from '../../../helpers/Fields/InputField';
import { renameOrganisation } from '../../actions';
class OrganisationName extends Component {
  static contextTypes = {formatMessage: PropTypes.any};

  constructor(props) {
    super(props);
    const {profile} = props;
    this.state = {
      isUpdate: false,
      name: profile.organisation_name || ''
    }
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.profile){
      this.setState({
        name: nextProps.profile.organisation_name || ''
      })
    }
  }

  save = async () => {
    const { isUpdate, name } = this.state;
    const {profile} = this.props;
    if(name){
      await this.props.renameOrganisation({id: profile.id, name});
      this.setState({isUpdate: false});
    }
   
  }
  
  render() {
    const {formatMessage} = this.context;
    const {profile} = this.props;
    const { isUpdate, name } = this.state;
    return (
      <div className="OrganisationName">
        {!isUpdate && <h3>{profile.organisation_name ? profile.organisation_name : formatMessage('notNameOrganisation') } <i onClick={()=> this.setState({isUpdate: true})} className="far fa-edit"></i> </h3>}
        {isUpdate && <div className="block-update">
          <InputField input={{
            value: name,
            onChange: (e) => {
              this.setState({name: e.target.value});
            }
          }} meta={{}} />
          <i onClick={this.save} className="far fa-save"></i>
          <i onClick={() => this.setState({isUpdate: false})} className="fas fa-times"></i>
        </div>}
      </div>
    );
  }
}



const mapStateToProps = (state, ownProps) => ({
  profile: profileSelector(state),
})

const mapDispatchToProps = {
  renameOrganisation
}

export default connect(mapStateToProps, mapDispatchToProps)(OrganisationName)



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/UserOrganisation/components/OrganisationName/index.jsx